import React, { useState } from 'react';
import './People.css';

// Import people images
import liyangImg from '../assets/people/liyang.jpg';
import matteoImg from '../assets/people/matteo.jpg';
import wanghongzheImg from '../assets/people/wanghongzhe.png';
import liyujianImg from '../assets/people/liyujian.jpg';
import lidianfengImg from '../assets/people/lidianfeng.jpg';
import gengyouImg from '../assets/people/gengyou.jpg';
import fushanchaoImg from '../assets/people/fushanchao.jpg';
import hanyuhuaImg from '../assets/people/hanyuhua.jpg';
import caoqiImg from '../assets/people/caoqi.jpg';
import wangxiaoyuImg from '../assets/people/wangxiaoyu.jpg';
import luyahuaiImg from '../assets/people/luyahuai.jpg';
import genghongmingImg from '../assets/people/genghongming.jpg';
import yanyihangImg from '../assets/people/yanyihang.jpg';
import chezhixinImg from '../assets/people/chezhixin.jpg';
import zhuxinruiImg from '../assets/people/zhuxinrui.jpg';
import chenjimiaoImg from '../assets/people/chenjiamiao.jpg';
import yuguoImg from '../assets/people/yuguo.jpg';
import zhuyuanzhangImg from '../assets/people/zhuyuanzhang.jpg';

function People({ language }) {
  const [selectedP1Character, setSelectedP1Character] = useState('liyang'); // Default P1 character
  const [selectedP2Character, setSelectedP2Character] = useState('matteo'); // Default P2 character
  const [hoveredCharacter, setHoveredCharacter] = useState(null);
  const [activePlayer, setActivePlayer] = useState(1); // Track which player is selecting

  const texts = {
    en: {
      title: 'Video Game and Art Research Center',
      subtitle: 'Peking University',
      selectCharacter: 'SELECT YOUR RESEARCHER',
      pressStart: 'PRESS START TO CONTINUE',
      coin: 'COIN 0/3',
      loading: 'LOADING...',
      statLabels: {
        favoriteGame: 'Favorite Game:',
        researchArea: 'Research Area:',
        researcherPhoto: 'Researcher Photo'
      },
      characterNames: {
        liyang: 'Li Yang',
        matteo: 'Matteo Ravasio',
        wanghongzhe: 'Wang Hongzhe',
        liyujian: 'Li Yujian',
        lidianfeng: 'Li Dianfeng',
        gengyou: 'Geng Youzimin',
        fushanchao: 'Fu Shanchao',
        hanyuhua: 'Han Yuhua',
        caoqi: 'Cao Qi',
        wangxiaoyu: 'Wang Xiaoyu',
        luyahuai: 'Lu Yahuai',
        genghongming: 'Geng Hongming',
        yanyihang: 'Yan Yihang',
        chezhixin: 'Che Zhixin',
        zhuxinrui: 'Zhu Xinrui',
        chenjiamiao: 'Chen Jiamiao',
        yuguo: 'Yu Guo',
        zhuyuanzhang: 'Zhu Yuanzhang'
      },
      characterTitles: {
        liyang: 'Center Director & Professor',
        matteo: 'Executive Director & Assistant Professor',
        wanghongzhe: 'Junior Fellow & Associate Professor',
        liyujian: 'Junior Fellow & Associate Professor at CUC',
        lidianfeng: 'Lecturer at CUC',
        gengyou: 'Junior Fellow',
        fushanchao: 'Independent Scholar',
        hanyuhua: 'Junior Fellow',
        caoqi: 'Lecturer',
        wangxiaoyu: 'Junior Fellow',
        luyahuai: 'Associate Professor at Yangtze University',
        genghongming: 'Lecturer at Tsinghua University',
        yanyihang: 'Junior Fellow',
        chezhixin: 'Junior Fellow',
        zhuxinrui: 'Junior Fellow',
        chenjiamiao: 'Editor',
        yuguo: 'Junior Fellow',
        zhuyuanzhang: 'Junior Fellow'
      },
      characterDescriptions: {
        liyang: 'Director of the PKU Video Game and Arts Research Center, Dean and Professor at the School of Arts, Peking University, and a doctoral advisor. He is a Young Changjiang Scholar of the Ministry of Education and Director of the PKU Center for Visual and Image Studies. He also serves as the chief editor of the Video Game Culture Classics Translation Series. Li is Vice President of the Aesthetic Education Committee of the China Association of Higher Education and a member of the inaugural National Committee for Aesthetic Education in Higher Education. His primary research interests lie in art theory, with a particular focus on experimental film history, essay films, video art, and game studies.',
        matteo: 'Executive Director of the PKU Video Game and Arts Research Center and Assistant Professor of Art Theory at Peking University’s School of Arts. His research and teaching interests are in aesthetics and philosophy of art, and especially in the philosophy of music. In 2024, he taught the course “Games and the Arts” (游戏与艺术) at Peking University’s School of Arts. He is currently working on a book based on the course. The book covers the recent debate in analytic philosophy on the nature of games and their relation to established art forms. When he is not working, he likes to play wargames.',
        wanghongzhe: 'Junior Fellow at the PKU Video Game and Arts Research Center. A media historian with a Ph.D. from the Chinese University of Hong Kong, he is currently Associate Professor with tenure and a research fellow at the School of Journalism and Communication, Peking University. His research spans media history, cybernetics, the information society, and new media studies. He initiated the research collectives "Beijing Media Group" and Game Manual, and co-founded the "Institute for Dismantling Things."',
        liyujian: 'Junior Fellow at the PKU Video Game and Arts Research Center. He holds a Ph.D. in Art Studies from Peking University and was a visiting scholar at the University of California, Santa Cruz. He is currently Associate Professor at the School of Theater, Film and Television Arts, Communication University of China. His research focuses on film theory and game studies, with work published in journals such as Contemporary Cinema, Film Art, Modern Communication, and Literature & Art Forum.',
        lidianfeng: 'Lecturer at the School of Animation and Digital Arts, Communication University of China. His teaching and research focus on e-sports and game studies, particularly game communication and regional/national perspectives. In 2025, he will teach Introduction to Game Studies at the School. Outside of work, he enjoys playing football with his family, Texas Hold\'em, and Werewolf. He also leads the E-sports Culture Training Program at the Research Center.',
        gengyou: 'Ph.D. candidate at the School of Arts, Peking University, and Junior Fellow at the PKU Video Game and Arts Research Center. Editorial board member of the Video Game Theory and History Classics Translation Series. His research explores the intersection of video game imagery and contemporary art, focusing on how video game visuals shape today\'s popular visual culture. A seasoned Steam curator and JRPG enthusiast, he has transitioned from AAA titles to indie games. He organizes the Boya International Conference on Game Studies.',
        fushanchao: 'Independent scholar with a Ph.D. in Chinese Literature from Peking University. His research spans game studies, critical theory, and popular culture. His current interests in game theory include re-examining core concepts such as agency, signification, genre, and virtual labor. A lifelong fan of JRPGs who never quite reconciled with his youthful obsession, he now prefers Nintendo titles (despite never owning an FC or GB) and harbors a strong dislike for its hardware. He organizes regular workshops on game studies.',
        hanyuhua: 'Junior Fellow at the PKU Video Game and Arts Research Center. He holds a Ph.D. in mathematics from Nankai University and is currently a postdoctoral researcher at the School of Arts, Peking University. His research explores the ontological and aesthetic dimensions of video games, as well as the philosophical foundation of game events.',
        caoqi: 'Editorial board member of the Video Game Theory and History Classics Translation Series, Ph.D. in History, and Lecturer at the Department of History of Science, Technology, and Medicine, Peking University. Her research focuses on the early history of video games, examining them within the combined contexts of technological culture, embodied experience, and educational thought. She teaches the course The History of How Video Games Reshaped the Human World at PKU.',
        wangxiaoyu: 'Ph.D. candidate at the School of Arts, Peking University, and Junior Fellow at the PKU Video Game and Arts Research Center. His research focuses on video game history and Chinese video game culture. He is currently exploring how the media formats of early Chinese video games recorded, transmitted, and shaped local gaming culture. He also co-organizes the Boya International Conference on Game Studies.',
        luyahuai: 'Associate Professor at the Department of Political Science, Yangtze University, and editorial board member of the Game Studies journal. Her research focuses on the techno-cultural history of games, historical game studies, media politics, and digital historiography. She curates the Historical Game Studies Translation Series and the Games × Everyday History publication project, while also promoting cross-disciplinary teaching and public engagement through courses and workshops.',
        genghongming: 'Lecturer at the Writing Center, School of Humanities, Tsinghua University. His research interests include Western literary theory, cybernetics and cyberculture, and digital humanities. His game-related research focuses on early computing history and its interaction with video games, exploring how games reflect the intellectual history of the post-WWII era. Childhood memories of the Famicom and arcade halls remain vivid; he once aspired to become an e-sports athlete, only to discover a lack of talent. He now enjoys learning programming during breaks in card games and safeguarding world peace in Paradox grand strategy titles.',
        yanyihang: 'Junior Fellow at the PKU Video Game and Arts Research Center. He holds a B.S. in Applied Mathematics and Statistics from SUNY Stony Brook and is currently a doctoral candidate at the School of Arts and Communication, Beijing Normal University. His research interests include game studies in the context of contemporary Chinese popular culture, tabletop games, and player studies.',
        chezhixin: 'Junior Fellow at the PKU Video Game and Arts Research Center and editorial board member of the Video Game Theory and History Classics Translation Series. He is currently an assistant research fellow at the Institute of Foreign Literature, Beijing Foreign Studies University.',
        zhuxinrui: 'Junior Fellow at the PKU Video Game and Arts Research Center and undergraduate student at Yuanpei College, Peking University, majoring in Art History and Theory. His research interests include horror games and the application of art historical methodologies to video games, with the aim of exploring emotional experiences in games and the possibilities for interdisciplinary approaches.',
        chenjiamiao: 'Master\'s graduate in Theater and Film from Peking University and editor for the Weiming Game public account. Her research interests focus on game narratives and game imagery, with particular attention to gamification, the convergence of games and film, and immersive experiences within the gaming industry context.',
        yuguo: 'Junior Fellow at the PKU Video Game and Arts Research Center and undergraduate at Dartmouth College. He is also a member of the Sunset-Sway Media Labs and curator of the Retro Games Museum (rgm.games). His work centers on the history of games and retro game culture, exploring play-centered museological approaches. He aims to foster cross-generational and cross-cultural resonance and reduce prejudice and misunderstanding. He is also interested in how creative constraints shape video game design.',
        zhuyuanzhang: 'Junior Fellow at the PKU Video Game and Arts Research Center, affiliated with the PKU Center for Visual and Image Studies. His main area of research is game studies.'
      },
      favoriteGames: {
        liyang: 'Unknown',
        matteo: 'Unknown',
        wanghongzhe: 'Unknown',
        liyujian: 'Unknown',
        lidianfeng: 'Unknown',
        gengyou: 'Unknown',
        fushanchao: 'Unknown',
        hanyuhua: 'Unknown',
        caoqi: 'Unknown',
        wangxiaoyu: 'Unknown',
        luyahuai: 'Unknown',
        genghongming: 'Unknown',
        yanyihang: 'Unknown',
        chezhixin: 'Unknown',
        zhuxinrui: 'Unknown',
        chenjiamiao: 'Unknown',
        yuguo: 'Unknown',
        zhuyuanzhang: 'Unknown'
      },
      researchAreas: {
        liyang: 'Unknown',
        matteo: 'Unknown',
        wanghongzhe: 'Unknown',
        liyujian: 'Unknown',
        lidianfeng: 'Unknown',
        gengyou: 'Unknown',
        fushanchao: 'Unknown',
        hanyuhua: 'Unknown',
        caoqi: 'Unknown',
        wangxiaoyu: 'Unknown',
        luyahuai: 'Unknown',
        genghongming: 'Unknown',
        yanyihang: 'Unknown',
        chezhixin: 'Unknown',
        zhuxinrui: 'Unknown',
        chenjiamiao: 'Unknown',
        yuguo: 'Unknown',
        zhuyuanzhang: 'Unknown'
      }
    },
    zh: {
      title: '电子游戏与艺术研究中心',
      subtitle: '北京大学',
      selectCharacter: '选择你的研究员',
      pressStart: 'Press Start to Continue',
      coin: '硬币 0/3',
      loading: '加载中...',
      statLabels: {
        favoriteGame: '最爱游戏：',
        researchArea: '研究领域：',
        researcherPhoto: '研究员照片'
      },
      characterNames: {
        liyang: '李洋',
        matteo: '芮玛窦',
        wanghongzhe: '王洪喆',
        liyujian: '李雨谏',
        lidianfeng: '李典峰',
        gengyou: '耿游子民',
        fushanchao: '傅善超',
        hanyuhua: '韩宇华',
        caoqi: '曹琪',
        wangxiaoyu: '王晓宇',
        luyahuai: '卢雅怀',
        genghongming: '耿弘明',
        yanyihang: '闫毅航',
        chezhixin: '车致新',
        zhuxinrui: '朱鑫瑞',
        chenjiamiao: '陈佳苗',
        yuguo: '俞果',
        zhuyuanzhang: '朱元璋'
      },
      characterTitles: {
        liyang: '中心主任&教授',
        matteo: '执行主任&助理教授',
        wanghongzhe: '青年研究员&副教授',
        liyujian: '青年研究员&中国传媒大学副教授',
        lidianfeng: '中国传媒大学讲师',
        gengyou: '青年研究员',
        fushanchao: '独立学者',
        hanyuhua: '青年研究员',
        caoqi: '讲师',
        wangxiaoyu: '青年研究员',
        luyahuai: '长江大学副教授',
        genghongming: '清华大学讲师',
        yanyihang: '青年研究员',
        chezhixin: '青年研究员',
        zhuxinrui: '青年研究员',
        chenjiamiao: '编辑',
        yuguo: '青年研究员',
        zhuyuanzhang: '青年研究员'
        
      },
      characterDescriptions: {
        liyang: '游戏与艺术创研中心主任，北京大学艺术学院院长、教授、博士生导师，教育部青年长江学者，北京大学视觉与图像研究中心主任，"游戏文化经典译丛"主编。中国高教学会美育专业委员会副理事长，首届全国高校美育教学指导委员会委员。主要研究艺术理论，尤其关注实验电影史、论文电影、录像艺术和游戏研究等领域。',
        matteo: '游戏与艺术创研中心执行主任，北京大学艺术学院艺术理论助理教授。研究与教学兴趣集中在美学与艺术哲学，尤其是音乐哲学领域。2024年在艺术学院开设"游戏与艺术"课程。目前正基于该课程撰写书籍，内容涵盖分析哲学中关于游戏本质及其与既有艺术形式关系的最新讨论。工作之余喜欢玩兵棋游戏。',
        wanghongzhe: '游戏与艺术创研中心青年研究员。媒介史学者，香港中文大学博士，北京大学新闻与传播学院研究员、长聘副教授、博士生导师。研究跨越多媒介、历史和影像，兴趣涉及媒介史、控制论史、信息社会与新媒介研究，游戏研究，是研究网络"北京媒介小组"和"游戏手册"的发起人，以及"拆东西研究所"联合发起人。',
        liyujian: '游戏与艺术创研中心青年研究员。北京大学艺术学博士，美国加州大学圣克鲁斯分校访问学者，中国传媒大学戏剧影视学院副教授。主要从事电影理论研究、游戏研究。文章见于《当代电影》《电影艺术》《现代传播》《文艺争鸣》《文艺论坛》等刊物。',
        lidianfeng: '中国传媒大学动画与数字艺术学院讲师。研究与教学兴趣集中在电子竞技与游戏研究，尤其是关于游戏传播与区域国别的研究。2025年在动画学院教授"游戏概论"课程。工作之余喜欢和家人踢球，德扑，狼人杀。主持创研中心电子竞技文化研修班。',
        gengyou: '北京大学艺术学院，伦敦国王学院数字人文系联合培养博士生，游戏与艺术创研中心青年研究员，电子游戏理论与历史经典译丛编委，主要研究电子游戏图像与当代艺术，目前兴趣集中在电子游戏图像的历史与现状，以及何以塑造当下的大众视觉文化，任索Steam三修。JRPG入坑，早年痴迷3A，最近偏爱Indie。组织博雅国际电子游戏学术年会。',
        fushanchao: '北京大学中文系博士，独立学者。主要研究方向为游戏研究、批评理论、和大众文化。游戏方向的主要研究兴趣目前集中在基础游戏理论，尝试重新审视能动性、表意、类型、和虚拟劳动等核心概念。年少时沉迷JRPG，学术生涯始终不愿与此和解；与研究不相关的游玩更偏好任天堂的作品，憾不曾拥有FC与GB，然而现在痛恨其硬件。组织游戏研究研讨班。',
        hanyuhua: '游戏与艺术创研中心青年研究员，南开大学数学博士，北京大学艺术学院博雅博士后。主要研究方向为电子游戏的哲学与艺术理论。近年来致力于发展兼顾了反本质主义与媒介独特性的电子游戏存在论与艺术理论，试图破解游戏研究中的一些固有症结，并由此引申出对类型概念的重思，尝试推进电子游戏的类型研究。希望重审游戏研究中的诸多核心概念 ，关注游戏研究与事件哲学的互动，坚信游戏研究是驱动人文理论发展的有力引擎。游戏生涯早期尤爱Valve、Arkane与《时空幻境》，后受《见证者》影响投入游戏研究，又接连见证《史蒂芬的香肠卷》《星际拓荒》《豆子与虚无》等伟大作品，现已不再执着于任何厂商与作者，更关注电子游戏在各种路径上的发展、成熟、衰退的个体化过程与相互影响，期待逻辑解谜之外的其他游戏类型中出现《香肠卷》式的伟大变革之作。',
        caoqi: '电子游戏理论与历史经典译丛编委，历史学博士，北京大学科学技术与医学史系讲师。目前关注早期电子游戏的历史，试图在技术文化、具身体验、教育思潮的复合语境下考察电子游戏，在北大开设电子游戏改造人类世界的历史课程。',
        wangxiaoyu: '北京大学艺术学院博士研究生，游戏与艺术创研中心青年研究员。研究方向为电子游戏史与中国电子游戏文化。目前尝试探索早期中国电子游戏的媒介载体如何记录、传播、塑造本土电子游戏文化。组织博雅国际电子游戏学术年会。',
        luyahuai: '长江大学马克思主义学院政治系特任副教授，《游戏研究》集刊编委会成员。主要研究方向为游戏的技术—文化史、历史游戏研究、媒介政治学与数字史学。策划历史游戏研究译丛与游戏×日常生活史系列文献出版项目，亦在相关课程与工作坊中尝试跨界教学与公众实践。',
        genghongming: '清华大学人文学院写作中心讲师。主要研究方向为西方文论、控制论与赛博文化、数字人文。游戏方向的研究兴趣，目前集中在早期计算机发展史与电子游戏的互动，电子游戏如何映射二战之后的思想史。童年时的红白机与街机回忆历久弥新，年少时最爱暴雪、R星与科乐美，曾梦想成为电竞选手，后发现天赋不够。现在日常利用卡牌游戏出牌间隙学习编程知识，或在P社四萌里保卫世界和平。',
        yanyihang: '游戏与艺术创研中心青年研究员，本科毕业于纽约州立大学石溪分校应用数学与统计系，北京师范大学文学硕士、艺术与传媒学院博士研究生。目前关注中国当代大众文化视野下的游戏研究、桌面游戏研究与玩家研究。',
        chezhixin: '游戏与艺术创研中心青年研究员，电子游戏理论与历史经典译丛编委，北京外国语大学外国文学研究所助理研究员。',
        zhuxinrui: '游戏与艺术创研中心青年研究员，北京大学元培学院艺术史论方向本科生。目前关注恐怖游戏研究与艺术史方法在电子游戏中的使用，希望探索电子游戏的情感体验与艺术史学科方法进入电子游戏研究的可能性。',
        chenjiamiao: '北京大学戏剧与影视专业硕士，未名游戏公众号编辑。研究兴趣与重点关注游戏叙事、游戏影像等方向，尝试在游戏化、影游结合、沉浸体验等游戏产业语境下进行理论研究。',
        yuguo: '游戏与艺术创研中心青年研究员，达特茅斯学院本科在读，落日间GSC成员，怀旧游戏博物馆(rgm.games)馆长。关注游戏史与复古游戏文化，正在探索以"游玩"为核心的游戏博物范式，试图激发跨代际与跨地域的文化共鸣，消弭偏见和误解。同时关注技术与形式限制下的电子游戏创作。',
        zhuyuanzhang: '北京大学艺术学院博士研究生，游戏与艺术创研中心青年研究员，任职于北京大学视觉与图像研究中心，主要从事游戏研究。'
      },
      favoriteGames: {
        liyang: 'Unknown',
        matteo: 'Unknown',
        wanghongzhe: 'Unknown',
        liyujian: 'Unknown',
        lidianfeng: 'Unknown',
        gengyou: 'Unknown',
        fushanchao: 'Unknown',
        hanyuhua: 'Unknown',
        caoqi: 'Unknown',
        wangxiaoyu: 'Unknown',
        luyahuai: 'Unknown',
        genghongming: 'Unknown',
        yanyihang: 'Unknown',
        chezhixin: 'Unknown',
        zhuxinrui: 'Unknown',
        chenjiamiao: 'Unknown',
        yuguo: 'Unknown',
        zhuyuanzhang: 'Unknown'
      },
      researchAreas: {
        liyang: 'Unknown',
        matteo: 'Unknown',
        wanghongzhe: 'Unknown',
        liyujian: 'Unknown',
        lidianfeng: 'Unknown',
        gengyou: 'Unknown',
        fushanchao: 'Unknown',
        hanyuhua: 'Unknown',
        caoqi: 'Unknown',
        wangxiaoyu: 'Unknown',
        luyahuai: 'Unknown',
        genghongming: 'Unknown',
        yanyihang: 'Unknown',
        chezhixin: 'Unknown',
        zhuxinrui: 'Unknown',
        chenjiamiao: 'Unknown',
        yuguo: 'Unknown',
        zhuyuanzhang: 'Unknown'
      }
    }
  };

  const characters = [
    { id: 'liyang', image: liyangImg, stance: 'confident' },
    { id: 'wanghongzhe', image: wanghongzheImg, stance: 'creative' },
    { id: 'liyujian', image: liyujianImg, stance: 'artistic' },
    { id: 'lidianfeng', image: lidianfengImg, stance: 'futuristic' },
    { id: 'gengyou', image: gengyouImg, stance: 'innovative' },
    { id: 'fushanchao', image: fushanchaoImg, stance: 'musical' },
    { id: 'hanyuhua', image: hanyuhuaImg, stance: 'interactive' },
    { id: 'caoqi', image: caoqiImg, stance: 'dynamic' },
    { id: 'wangxiaoyu', image: wangxiaoyuImg, stance: 'inclusive' },
    { id: 'matteo', image: matteoImg, stance: 'analytical' },
    { id: 'luyahuai', image: luyahuaiImg, stance: 'entrepreneurial' },
    { id: 'genghongming', image: genghongmingImg, stance: 'confident' },
    { id: 'yanyihang', image: yanyihangImg, stance: 'analytical' },
    { id: 'chezhixin', image: chezhixinImg, stance: 'creative' },
    { id: 'zhuxinrui', image: zhuxinruiImg, stance: 'artistic' },
    { id: 'chenjiamiao', image: chenjimiaoImg, stance: 'futuristic' },
    { id: 'yuguo', image: yuguoImg, stance: 'innovative' },
    { id: 'zhuyuanzhang', image: zhuyuanzhangImg, stance: 'scholarly' }
  ];

  const currentTexts = texts[language];

  // Split characters into two groups of 9 for the dual grids
  const p1Characters = characters.slice(0, 9);
  const p2Characters = characters.slice(9, 18);

  // Derived selections based on active player (used in mobile layout)
  const activeSelectedCharacter = activePlayer === 1 ? selectedP1Character : selectedP2Character;
  const activeGridCharacters = activePlayer === 1 ? p1Characters : p2Characters;

  const handleCharacterSelect = (characterId, player) => {
    if (player === 1) {
      setSelectedP1Character(characterId);
    } else {
      setSelectedP2Character(characterId);
    }
    setActivePlayer(player);
  };

  return (
    <div className="people-page">

      {/* Mobile Layout: Fixed VS bar + swipeable panels for P1 and P2 */}
      <div className="mobile-people">
        {/* VS Bar */}
        <div className="mobile-versus-bar" role="toolbar" aria-label="Versus bar">
          <button className="nameplate p1" onClick={() => setActivePlayer(1)} aria-pressed={activePlayer === 1}>
            <span className="mini-portrait">
              <img
                src={characters.find(c => c.id === selectedP1Character)?.image}
                alt={currentTexts.characterNames[selectedP1Character]}
              />
            </span>
            <span className="label" lang={language}>1P</span>
            <span className="life"><span className="fill p1" /></span>
          </button>

          <div className="mobile-timer" aria-hidden="true">VS</div>

          <button className="nameplate p2" onClick={() => setActivePlayer(2)} aria-pressed={activePlayer === 2}>
            <span className="life"><span className="fill p2" /></span>
            <span className="label" lang={language}>2P</span>
            <span className="mini-portrait">
              <img
                src={characters.find(c => c.id === selectedP2Character)?.image}
                alt={currentTexts.characterNames[selectedP2Character]}
              />
            </span>
          </button>
        </div>

        {/* Single active-player section (with 1P/2P toggle) */}
        <div className={`mobile-info ${activePlayer === 1 ? 'p1' : 'p2'}`}>
          {activeSelectedCharacter && (
            <div className="mobile-info-inner">
              <div className="mobile-image floating-animation">
                <img
                  src={characters.find(c => c.id === activeSelectedCharacter)?.image}
                  alt={currentTexts.characterNames[activeSelectedCharacter]}
                />
              </div>
              <div className="mobile-texts">
                <h3 lang={language}>{currentTexts.characterNames[activeSelectedCharacter]}</h3>
                <p lang={language}>{currentTexts.characterTitles[activeSelectedCharacter]}</p>
                <div className="character-stats">
                  <div className="stat-item">
                    <span lang={language}>{currentTexts.statLabels.favoriteGame}</span>
                    <span lang={language}>{currentTexts.favoriteGames[activeSelectedCharacter]}</span>
                  </div>
                  <div className="stat-item">
                    <span lang={language}>{currentTexts.statLabels.researchArea}</span>
                    <span lang={language}>{currentTexts.researchAreas[activeSelectedCharacter]}</span>
                  </div>
                </div>
                <div className="character-description">
                  <p lang={language}>{currentTexts.characterDescriptions[activeSelectedCharacter]}</p>
                </div>
              </div>
            </div>
          )}
        </div>

        <div className={`mobile-grid ${activePlayer === 1 ? 'p1-grid' : 'p2-grid'}`}>
          <div className="grid-label mobile-toggle" role="group" aria-label="Player selector">
            <button
              type="button"
              className={`toggle-btn ${activePlayer === 1 ? 'active' : ''}`}
              onClick={() => setActivePlayer(1)}
              aria-pressed={activePlayer === 1}
            >
              1P
            </button>
            <button
              type="button"
              className={`toggle-btn ${activePlayer === 2 ? 'active' : ''}`}
              onClick={() => setActivePlayer(2)}
              aria-pressed={activePlayer === 2}
            >
              2P
            </button>
          </div>
          <div className="character-grid">
            {activeGridCharacters.map((character) => (
              <div
                key={character.id}
                className={`character-cell ${(activePlayer === 1 ? selectedP1Character : selectedP2Character) === character.id ? 'selected' : ''} ${hoveredCharacter === character.id ? 'hovered' : ''}`}
                onClick={() => handleCharacterSelect(character.id, activePlayer)}
                onMouseEnter={() => setHoveredCharacter(character.id)}
                onMouseLeave={() => setHoveredCharacter(null)}
              >
                <div className="character-portrait">
                  <img src={character.image} alt={currentTexts.characterNames[character.id]} />
                </div>
                <div className="character-name" lang={language}>
                  {currentTexts.characterNames[character.id]}
                </div>
                {(activePlayer === 1 ? selectedP1Character : selectedP2Character) === character.id && (
                  <div className="selection-indicator">
                    <div className="selection-corners">
                      <div className="corner top-left"></div>
                      <div className="corner top-right"></div>
                      <div className="corner bottom-left"></div>
                      <div className="corner bottom-right"></div>
                    </div>
                  </div>
                )}
              </div>
            ))}
          </div>
          <div className="battle-ready-section">
            <div className="start-prompt" lang={language}>{currentTexts.pressStart}</div>
          </div>
        </div>
      </div>

      {/* Desktop Layout */}
      <div className="sf2-container">
        {/* Main Content Layout */}
        <div className="main-content">
          {/* Left Side - P1 Info and Character */}
          <div className="left-side">
            <div className="p1-info">
              {selectedP1Character && (
                <div className="character-details">
                  <h3 lang={language}>{currentTexts.characterNames[selectedP1Character]}</h3>
                  <p lang={language}>{currentTexts.characterTitles[selectedP1Character]}</p>
                  <div className="character-stats">
                    <div className="stat-item">
                      <span lang={language}>{currentTexts.statLabels.favoriteGame}</span>
                      <span lang={language}>{currentTexts.favoriteGames[selectedP1Character]}</span>
                    </div>
                    <div className="stat-item">
                      <span lang={language}>{currentTexts.statLabels.researchArea}</span>
                      <span lang={language}>{currentTexts.researchAreas[selectedP1Character]}</span>
                    </div>
                  </div>
                  <div className="character-description">
                    <p lang={language}>{currentTexts.characterDescriptions[selectedP1Character]}</p>
                  </div>
                </div>
              )}
            </div>
            
            {/* Player 1 Character Display */}
            <div className="player-character p1-character">
              {selectedP1Character && (
                <div className="character-showcase">
                  <div className="character-image-large floating-animation">
                    <img 
                      src={characters.find(c => c.id === selectedP1Character)?.image} 
                      alt={currentTexts.characterNames[selectedP1Character]}
                    />
                  </div>
                </div>
              )}
            </div>
          </div>
          
          {/* Center - Selection Grids and VS */}
          <div className="center-section">
            <div className="selection-area">
              <div className="vs-section">
                <div className="vs-text">VS</div>
              </div>
              
              {/* Character Selection Grids */}
              <div className="selection-grids">
              {/* Player 1 Grid */}
              <div className="player-grid p1-grid">
                <div className="grid-label">1P</div>
                <div className="character-grid">
                  {p1Characters.map((character, index) => (
                    <div
                      key={character.id}
                      className={`character-cell ${
                        selectedP1Character === character.id ? 'selected' : ''
                      } ${
                        hoveredCharacter === character.id ? 'hovered' : ''
                      }`}
                      onClick={() => handleCharacterSelect(character.id, 1)}
                      onMouseEnter={() => setHoveredCharacter(character.id)}
                      onMouseLeave={() => setHoveredCharacter(null)}
                    >
                      <div className="character-portrait">
                        <img src={character.image} alt={currentTexts.characterNames[character.id]} />
                      </div>
                      <div className="character-name" lang={language}>
                        {currentTexts.characterNames[character.id]}
                      </div>
                      {selectedP1Character === character.id && (
                        <div className="selection-indicator">
                          <div className="selection-corners">
                            <div className="corner top-left"></div>
                            <div className="corner top-right"></div>
                            <div className="corner bottom-left"></div>
                            <div className="corner bottom-right"></div>
                          </div>
                        </div>
                      )}
                    </div>
                  ))}
                </div>
              </div>
              
              {/* Player 2 Grid */}
              <div className="player-grid p2-grid">
                <div className="grid-label">2P</div>
                <div className="character-grid">
                  {p2Characters.map((character, index) => (
                    <div
                      key={character.id}
                      className={`character-cell ${
                        selectedP2Character === character.id ? 'selected' : ''
                      } ${
                        hoveredCharacter === character.id ? 'hovered' : ''
                      }`}
                      onClick={() => handleCharacterSelect(character.id, 2)}
                      onMouseEnter={() => setHoveredCharacter(character.id)}
                      onMouseLeave={() => setHoveredCharacter(null)}
                    >
                      <div className="character-portrait">
                        <img src={character.image} alt={currentTexts.characterNames[character.id]} />
                      </div>
                      <div className="character-name" lang={language}>
                        {currentTexts.characterNames[character.id]}
                      </div>
                      {selectedP2Character === character.id && (
                        <div className="selection-indicator">
                          <div className="selection-corners">
                            <div className="corner top-left"></div>
                            <div className="corner top-right"></div>
                            <div className="corner bottom-left"></div>
                            <div className="corner bottom-right"></div>
                          </div>
                        </div>
                      )}
                    </div>
                  ))}
                </div>
              </div>
            </div>
            </div>
            
            {/* Battle Ready Section */}
            <div className="battle-ready-section">
              <div className="start-prompt" lang={language}>{currentTexts.pressStart}</div>
              <div className="coin-counter" lang={language}>{currentTexts.coin}</div>
            </div>
          </div>
          
          {/* Right Side - P2 Info and Character */}
          <div className="right-side">
            <div className="p2-info">
              {selectedP2Character && (
                <div className="character-details">
                  <h3 lang={language}>{currentTexts.characterNames[selectedP2Character]}</h3>
                  <p lang={language}>{currentTexts.characterTitles[selectedP2Character]}</p>
                  <div className="character-stats">
                    <div className="stat-item">
                      <span lang={language}>{currentTexts.statLabels.favoriteGame}</span>
                      <span lang={language}>{currentTexts.favoriteGames[selectedP2Character]}</span>
                    </div>
                    <div className="stat-item">
                      <span lang={language}>{currentTexts.statLabels.researchArea}</span>
                      <span lang={language}>{currentTexts.researchAreas[selectedP2Character]}</span>
                    </div>
                  </div>
                  <div className="character-description">
                    <p lang={language}>{currentTexts.characterDescriptions[selectedP2Character]}</p>
                  </div>
                </div>
              )}
            </div>
            
            {/* Player 2 Character Display */}
            <div className="player-character p2-character">
              {selectedP2Character && (
                <div className="character-showcase">
                  <div className="character-image-large floating-animation">
                    <img 
                      src={characters.find(c => c.id === selectedP2Character)?.image} 
                      alt={currentTexts.characterNames[selectedP2Character]}
                    />
                  </div>
                </div>
              )}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default People;
